export enum OriginSystem {
  bandp,
  bpn,
}
